import BaseAppLayout from "../../layouts/BaseAppLayout/BaseAppLayout";
import { Toaster } from "react-hot-toast";
import Typography from "../../components/Typography/Typography";
import { Link } from "react-router-dom";

export default function Roadmap() {
  return (
    <BaseAppLayout headerText="Libreria">
      <Toaster />
      <div className="w-full flex flex-col items-center h-full px-6 lg:px-[120px] pt-10 pb-12 md:pb-20 justify-between">
        <div className="flex flex-col gap-3">
          <Typography
            size="36"
            desktopSize="48"
            family="serif"
            weight="sb"
            align="center"
          >
            Manca poco!
          </Typography>
          <div className="flex flex-col gap-2 justify-center items-center">
            <Typography
              size="16"
              desktopSize="20"
              weight="md"
              align="center"
            >
              Per generare la tua mappa di lavoro, crea prima il tuo indice!
            </Typography>
            <Link to="/client/index">
              <Typography
                size="16"
                desktopSize="20"
                weight="sb"
                align="center"
                underline={true}
              >
                Vai all'indice
              </Typography>
            </Link>
          </div>
        </div>

        <div className="h-96 w-auto overflow-hidden">
          <img
            alt="placeholderimage"
            src="/assets/images/illustrations/stats.png"
            className="object-contain w-full h-full"
          />
        </div>

      </div>
    </BaseAppLayout>
  );
}
